import { Box, Button, Checkbox, Chip, Typography } from "@mui/material";
import { useState } from "react";
import { formatCurrency } from "src/helper/convertNum";
import { v4 as uuid } from "uuid";
import { TYPE } from "../const/constants";
import convertCurrency from "src/helper/convertCurrency";
import { renderDebtAmountByInventoryType } from "../utils/renderDebtAmountByInventoryType";
import useCustomerList from "src/hooks/user/customer/useCustomerList";
import { payloadFilter } from "src/constant";

export default function useDebtSalesOverdueTab() {
  const [pagi, setPagi] = useState({limit: 50, skip:0})
  const [checkedList, setCheckedList] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);

  const { data: customer } = useCustomerList({ sortField: "totalDebt", sortOrder: payloadFilter.sortOrder });

  const handleChangeCheckbox = (checked, item) => {
    if (checked) {
      setCheckedList((prev) => [...prev, item]);
    } else {
      setCheckedList((prev) => prev.filter((checkedItem) => checkedItem?._id !== item?._id));
    }
  };

  const handleChangeCheckboxAll = (checked) => {
    if (checked) {
      setCheckedList(customer?.data?.map((item) => item));
    } else {
      setCheckedList([]);
    }
  };

  const bodyList = Array.isArray(customer?.data)
    ? customer?.data?.map((v, i) => ({
        ...v,
        checkbox: (
          <Checkbox
            checked={checkedList.some((checkedItem) => checkedItem?._id === v?._id)}
            onChange={(_, checked) => handleChangeCheckbox(checked, v)}
          />
        ),
        no: i + 1,
        customerName: v?.fullName ?? "-",
        salesStaff: v?.sales?.fullName ?? "-",
        creditLimit: (
          <>
            <Typography fontWeight="bold">{formatCurrency(v?.debtLimit ?? 0)}</Typography>
            <Typography
              color="#989898"
              fontSize="8px"
              fontStyle="italic"
            >
              {convertCurrency(v?.debtLimit ?? 0)} đồng
            </Typography>
          </>
        ),
        currentDebt: renderDebtAmountByInventoryType(v?.totalDebt, v.type ?? TYPE.OUTBOUND),
        outstandingBalance: (
          <>
            <Typography fontWeight="bold">{formatCurrency(v?.balance ?? 0)}</Typography>
            <Typography
              color="#989898"
              fontSize="8px"
              fontStyle="italic"
            >
              {convertCurrency(v?.balance ?? 0)} đồng
            </Typography>
          </>
        ),
        status: (
          <Chip
            label={Number(v?.debtLimit) > 0 ? ((Number(v?.totalDebt || 0) / Number(v?.debtLimit)) * 100).toFixed(2) + "% hạn mức" : "0.00% hạn mức"}
            color={(Number(v?.totalDebt || 0) / Number(v?.debtLimit || 1)) * 100 >= 90 ? "error" : "warning"}
            size="small"
          />
        ),
        action: (
          <Box
            display="flex"
            gap="8px"
            justifyContent="flex-end"
          >
            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={() => setSelectedRow(v)}
              sx={{ minWidth: "100px" }}
            >
              Thanh toán
            </Button>
          </Box>
        ),
      }))
    : [];

  const header = [
    {
      id: uuid(),
      title: (
        <Checkbox
          checked={checkedList.length === customer?.data?.length}
          onChange={(_, checked) => handleChangeCheckboxAll(checked)}
        />
      ),
      align: "center",
    },
    { id: uuid(), title: "STT", align: "center" },
    { id: uuid(), title: "Tên Khách hàng", align: "center" },
    { id: uuid(), title: "Nhân viên kinh doanh", align: "center" },
    { id: uuid(), title: "Tổng hạn mức công nợ", align: "center" },
    { id: uuid(), title: "Công nợ hiện tại", align: "center" },
    { id: uuid(), title: "Số dư chưa gạt nợ ", align: "center" },
    { id: uuid(), title: "Trạng thái", align: "center" },
    { id: uuid(), title: "Thao tác", align: "center" },
  ];

  const sortData = ["checkbox", "no", "customerName", "salesStaff", "creditLimit", "currentDebt", "outstandingBalance", "status", "action"];

  return { bodyList,pagi, setPagi, total: customer?.count ?? 0, header, sortData, checkedList, selectedRow, setSelectedRow };
}
